import React, { useMemo } from 'react';
import ChartLegend from '../internal/components/chart-legend';
import { chartLegendMap } from './utils';
function InternalChartLegend(_a) {
    var series = _a.series, visibleSeries = _a.visibleSeries, highlightedSeries = _a.highlightedSeries, onHighlightChange = _a.onHighlightChange, legendTitle = _a.legendTitle, ariaLabel = _a.ariaLabel;
    var legendItems = useMemo(function () {
        return series
            .filter(function (s) { return visibleSeries.indexOf(s.series) !== -1; })
            .map(function (_a) {
            var series = _a.series, color = _a.color;
            return ({
                label: series.title,
                type: chartLegendMap[series.type],
                color: color,
                datum: series
            });
        });
    }, [series, visibleSeries]);
    var highlightedLegendItem = useMemo(function () {
        if (!highlightedSeries) {
            return null;
        }
        var matches = legendItems.filter(function (item) { return item.datum === highlightedSeries; });
        return matches[0] || null;
    }, [legendItems, highlightedSeries]);
    return (React.createElement(ChartLegend, { series: legendItems, highlightedSeries: highlightedLegendItem, onHighlightChange: onHighlightChange, legendTitle: legendTitle, ariaLabel: ariaLabel }));
}
export default InternalChartLegend;
//# sourceMappingURL=chart-legend.js.map